import imageGenegator from './handlers/imageGenerator';

export default {
  handlers: {
    imageGenegator,
  },
};
